/* unplugin-vue-components disabled */import { render } from "./Home2.vue?vue&type=template&id=c77a775a&scoped=true"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"

import "./Home2.vue?vue&type=style&index=0&id=c77a775a&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77a775a"]])

export default __exports__